module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "home-page",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    staticClass: "home-page__content",
    attrs: {
      "xs12": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('h1', {
    staticClass: "home-page__hello"
  }, [_vm._v(" Hi, I'm Joe.")]), _vm._v(" "), _c('v-carousel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.drawer),
      expression: "!drawer"
    }],
    ref: "home-carousel",
    staticClass: "elevation-0",
    attrs: {
      "cycle": "",
      "dark": "",
      "interval": 6000000,
      "leftControlIcon": false,
      "id": "home-carousel"
    }
  }, _vm._l((_vm.sliderData), function(item, i) {
    return _c('v-carousel-item', {
      key: i,
      attrs: {
        "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
      }
    }, [_c('div', {
      staticClass: "home-page__typer-container"
    }, [_c('h2', [_vm._v("I " + _vm._s(i) + " ")]), _vm._v(" "), _c('div', [_c('vue-typer', {
      ref: "home-typer",
      refInFor: true,
      attrs: {
        "text": _vm.sliderData[i],
        "shuffle": false,
        "initial-action": "typing",
        "pre-type-delay": 70,
        "type-delay": 60,
        "pre-erase-delay": 750,
        "erase-delay": 200,
        "erase-style": "select-all",
        "caret-animation": "blink"
      },
      on: {
        "erased": function (e) {
          _vm.onErased(e, i);
        }
      }
    })], 1)])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.drawer),
      expression: "!drawer"
    }],
    staticClass: "home-page__btn-container"
  }, [_c('v-btn', {
    class: [_vm.settingsObj.themeColor, 'darken-2', 'white--text', 'home-page__btn-next', 'text-lg-right'],
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.infoModal = true
      }
    }
  }, [_vm._v("Who?\n            ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    ref: "btn-next",
    class: [_vm.settingsObj.themeColor, 'darken-2', 'white--text', 'home-page__btn-next', 'text-lg-right'],
    on: {
      "click": _vm.clickNext
    }
  }, [_vm._v("Tell me more!\n            ")])], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "home-page__dialog",
    attrs: {
      "width": "70%"
    },
    model: {
      value: (_vm.infoModal),
      callback: function($$v) {
        _vm.infoModal = $$v
      },
      expression: "infoModal"
    }
  }, [_c('v-card', {
    staticClass: "home-page__info-modal"
  }, [_c('v-card-title', {
    staticClass: "headline",
    class: [_vm.settingsObj.themeColor, 'lighten-1', 'headline', 'white--text', 'home-page__btn-next', 'text-lg-right']
  }, [_vm._v("About Me\n                ")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("\n                        Hello and welcome to my Portfolio site! My name is Joe Sangiorgio and I'm currently a Senior\n                        Front End Engineer at Marvel Entertainment. I have a passion for all things Javascript, and\n                        love creating meaningful data-driven web applications.")]), _vm._v(" "), _c('p', [_vm._v("\n                        I made this app in order to have an interesting space to showcase the type of work I love\n                        doing. My goal was to create an environment that would present my professional products in a\n                        unique and compelling way. I also just wanted to play with some flashy cutting-edge web\n                        technologies! 🤓")]), _vm._v(" "), _c('p', [_vm._v("\n                        I hope you have as much fun exploring this app as I did building it. Thanks for\n                        visiting!")]), _vm._v(" "), _c('p', [_vm._v("-Joe")]), _vm._v(" "), _c('v-flex', {
    staticClass: "home-page__profile-photo"
  }, [_c('div', [_c('img', {
    attrs: {
      "width": "90%",
      "src": require("../../assets/pics/joe.jpg"),
      "alt": "joe"
    }
  })])])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    class: ['darken-2', ((_vm.settingsObj.themeColor) + "--text")],
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.infoModal = false
      }
    }
  }, [_vm._v("Cool!\n                    ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0779b7bd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Home.vue
// module id = 452
// module chunks = 0